import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import ProductInventory from "../../../model/ProductInventory";
import Product from "@system/config/product";
import axios_c_for_price_and_inventory from "src/service/axios_c_for_price_and_inventory";
import { __remove, __set } from "../../axios_indicator";
import { isArray } from "underscore";
import ProductRepository from "../../../repository/ProductRepository";
import storeInUse from "../../../storeWire";
import Helper from "src/support/Helper";
import ProductInventoryAPICall from "src/service/ProductInventoryAPICall";

export const fetchInventoryFromServer = createAsyncThunk(
    'product_inventory_fetchInventoryFromServer',
    async (res) => {
        return res
    });

const slice = createSlice({
    name: "ProductInventory",
    initialState: {
        data: {},
        master_data: {}
    },
    reducers: {
        setAll: {
            reducer: (state, action) => {
                //Stopping unnecessary
                //state.data = action.payload.data
            },
        },
    },
    extraReducers: {
        [fetchInventoryFromServer.fulfilled]: (state, { payload }) => {
            __remove('PRODUCT_INVENTORY_API_CALL');
            let data = payload.data;
            data = new ProductInventory().matchAll(data);
            data = new ProductInventory().processAll(data);
            data = Object.entries(data);
            if (data.length) {
                data.map((v, i) => {
                    // if (v[1].product_contract_string !== undefined) {
                    //     state.master_data[v[1].product_contract_string] = v[1]
                    // }
                    state.master_data[v[1].ERPPartNumber] = v[1]
                    if (v[1].ItemNumber !== undefined) {
                        state.master_data[v[1].ItemNumber] = v[1]
                    }
                });
            }
        },
        [fetchInventoryFromServer.rejected]: (state, { payload }) => {
            __remove('PRODUCT_INVENTORY_API_CALL');
        },
    },
})
    ;

export let { setAll } = slice.actions;

export default slice.reducer;
